<template>
  <span v-if="homepageD">
    <div v-if="$auth.auth" class="d-flex align-items-center text-decoration-none" style="cursor: pointer;" @click="$emit('input', !value)">
      <i class="fas fa-bookmark text-primary mobile-b" style="position: inherit; font-size: 43px;"></i>
      <i
        :class="{ fas: value, fa: !value, 'fa-spin': loading, 'text-white': !value, 'text-warning': value }"
        :title="value? 'Click to remove this from your likes' : $t('like_tooltip')"
        class="fa fa-star pointer mobile-s"
        style="position: absolute; margin-left: 7px; margin-top: -5px; font-size: 18px;"
      ></i>&nbsp;&nbsp;
      <span v-if="$auth.auth" class="text-primary">Like network</span>
    </div>
  </span>
  <span v-else-if="homepageM">
    <i v-if="$auth.auth" class="fas fa-bookmark text-primary mobile-b" style="position: absolute; font-size: 43px;"></i>
    <i
      v-if="$auth.auth"
      :class="{ fas: value, fa: !value, 'fa-spin': loading, 'text-white': !value, 'text-warning': value }"
      :title="value? 'Click to remove this from your likes' : $t('like_tooltip')"
      class="fa fa-star pointer mobile-s"
      style="position: absolute; margin-left: 4px; margin-top: 5px;"
      @click="$emit('input', !value)"
    ></i>
  </span>
  <span v-else-if="media">
    <div v-if="$auth.auth" class="dropdown-item d-flex align-items-center text-decoration-none" style="cursor: pointer;" @click="$emit('input', !value)">
      <i class="fas fa-bookmark text-primary mt-1" style="position: inherit; font-size: 20px;"></i>
      <i
        :class="{ fas: value, fa: !value, 'fa-spin': loading, 'text-white': !value, 'text-warning': value }"
        :title="value? 'Click to remove this from your likes' : $t('like_tooltip')"
        class="fa fa-star pointer"
        style="font-size: 8px; position: absolute; margin-left: 3.5px; margin-top: 0px;"
      ></i>&nbsp;&nbsp;
      <span v-if="$auth.auth">
        <span v-if="value">Liked</span>
        <span v-else>{{ $t('like') }}</span>
      </span>
    </div>
  </span>
  <span v-else-if="course">
    <div v-if="$auth.auth" class="dropdown-item d-flex align-items-center text-decoration-none px-0" style="cursor: pointer;" @click="$emit('input', !value)">
      <i class="fas fa-bookmark text-primary" style="position: inherit; font-size: 33px;"></i>
      <i
        :class="{ fas: value, fa: !value, 'fa-spin': loading, 'text-white': !value, 'text-warning': value }"
        :title="value? 'Click to remove this from your likes' : $t('like_tooltip')"
        class="fa fa-star pointer"
        style="font-size: 15px; position: absolute; margin-left: 4.5px; margin-top: -6px;"
      ></i>&nbsp;&nbsp;
      <h4 v-if="$auth.auth" class="text-primary" style="margin: inherit;">
        <span v-if="value">Liked</span>
        <span v-else>{{ $t('like') }}</span>
      </h4>
    </div>
  </span>
  <span v-else>
    <i v-if="$auth.auth" class="fas fa-bookmark text-primary" style="position: absolute; margin-left: -14.5px; font-size: 28px; margin-top: -8px;"></i>
    <i
      v-if="$auth.auth"
      :class="{ fas: value, fa: !value, 'fa-spin': loading, 'text-white': !value, 'text-warning': value }"
      :title="value? 'Click to remove this from your likes' : $t('like_tooltip')"
      class="fa fa-star pointer"
      style="font-size: 13px; position: absolute; margin-left: -12px; margin-top: -4px;"
      @click="$emit('input', !value)"
    ></i>
  </span>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    homepageD: {
      type: Boolean,
      default: false,
    },
    homepageM: {
      type: Boolean,
      default: false,
    },
    media: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style>
@media (max-width: 600px) {
  .mobile-b {
    font-size: 20px !important;
    padding-top: 5px !important;
  }
  .mobile-s {
    margin-left: 2px !important;
    margin-top: 6px !important;
    font-size: 10px !important;
  }
}
@media (min-width: 601px) and (max-width: 990px) {
  .mobile-b {
    margin-top: 5px !important;
    font-size: 2rem !important;
  }
  .mobile-s {
    font-size: 1rem !important;
    margin-left: 3px !important;
    margin-top: 9px !important;
  }
}
</style>